import { createFileRoute } from "@tanstack/react-router";
import CustomersScreen from "../Screens/Customers";

export const Route = createFileRoute("/customers")({
  component: RouteComponent,
});

function RouteComponent() {
  return <CustomersScreen />;
}
